import ServicePayload from "@/models/server/ServicePayload";

export default class SaveServiceRequest {
    public servicePayload : ServicePayload = new ServicePayload();
}